module.exports = __webpack_public_path__ + "img/dinoc.65f25a0a.png";